// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Modal_overlay__2Oiz0","content":"Modal_content__3FOJt","closeButton":"Modal_closeButton__8C_Tm"};